import React, { FC } from 'react'
import { InputDateTime } from '../../../../components/input';

interface IDateSelect {
  onStartDateSelect?: any,
  onEndDateSelect?: any,
  startDate?: any
  endDate?: any,
  minDate?: any
}

const DateRangeSelect: FC<IDateSelect> = (props) => {
  const { onStartDateSelect, onEndDateSelect, startDate, endDate, minDate } = props;

  return (
    <div className="InputWraper">
      <div className="d-flex align-items-center wraper">
        <div className="input">
          <InputDateTime
            onChange={onStartDateSelect}
            value={startDate}
            onTouched={() => { }}
            name={'start'}
          />
        </div>
        <span className="px-2">{'đến'}</span>
        <div className="input">
          <InputDateTime
            onChange={onEndDateSelect}
            value={endDate}
            minDate={minDate}
            name={'end'}
            onTouched={() => { }}
          />
        </div>
      </div>
    </div>

  )
}

export default DateRangeSelect;